import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { GRID_COLUMN_DEFAULT_PROPERTIES } from '@constants';
import { GridCellLinkV2 } from 'components/common/grid';
import { URLS } from 'layouts/DrawerLayout/constants';
import { GENERIC_TICKETS_STATUS } from '../constants';

const renderTicketIdCell = (params) => {
  const { value } = params;
  if (!value) return '-';

  return (
    <GridCellLinkV2 href={`${URLS.genericTickets}/${value}`} target="_self">
      {value}
    </GridCellLinkV2>
  );
};

const renderStatusCell = (params) => {
  const { row } = params;
  const statusConfig = GENERIC_TICKETS_STATUS[row?.status];

  if (!statusConfig) return '-';

  return (
    <Box
      sx={{
        ...statusConfig.styles,
        padding: '4px 8px',
        borderRadius: '20px',
        fontSize: '12px',
        fontWeight: 500,
      }}
    >
      {statusConfig.label}
    </Box>
  );
};

const renderSubscriptionIdCell = (params) => {
  const { value } = params;
  if (!value) return '-';

  return (
    <GridCellLinkV2 href={`${URLS.subscriptions}/${value}`} target="_self">
      {value}
    </GridCellLinkV2>
  );
};

const renderBookingIdCell = (params) => {
  const { value } = params;
  if (!value) return '-';

  return (
    <GridCellLinkV2 href={`${URLS.bookings}/${value}`} target="_self">
      {value}
    </GridCellLinkV2>
  );
};

const useColumns = () => {
  const columns = useMemo(
    () => [
      {
        field: 'ticketId',
        headerName: 'Ticket ID',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 220,
        renderCell: renderTicketIdCell,
      },
      {
        field: 'ticketType',
        headerName: 'Ticket Type',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 150,
      },
      {
        field: 'subscriptionId',
        headerName: 'Subscription ID',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: false,
        filterable: false,
        width: 250,
        renderCell: renderSubscriptionIdCell,
      },
      {
        field: 'bookingId',
        headerName: 'Booking ID',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: false,
        filterable: false,
        width: 250,
        renderCell: renderBookingIdCell,
      },
      {
        field: 'status',
        headerName: 'Status',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 130,
        renderCell: renderStatusCell,
      },
      {
        field: 'team',
        headerName: 'Team',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 130,
      },
      {
        field: 'assignee',
        headerName: 'Assigned To',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 200,
      },
      {
        field: 'userId',
        headerName: 'User ID',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 150,
      },
      {
        field: 'username',
        headerName: 'Username',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 200,
      },
      {
        field: 'email',
        headerName: 'Email',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 220,
      },
      {
        field: 'phoneNumber',
        headerName: 'Phone Number',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 160,
      },
      {
        field: 'description',
        headerName: 'Description',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 250,
      },
      {
        field: 'createdAt',
        headerName: 'Created At',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 160,
      },
      {
        field: 'createdBy',
        headerName: 'Created By',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 220,
      },
      {
        field: 'dueDate',
        headerName: 'Due Date & Time',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 160,
      },
      {
        field: 'priority',
        headerName: 'Priority',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 160,
      },
      {
        field: 'reason',
        headerName: 'Ticket Reason',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 200,
      },
      {
        field: 'completedAt',
        headerName: 'Completed At',
        ...GRID_COLUMN_DEFAULT_PROPERTIES,
        sortable: true,
        filterable: false,
        width: 160,
      },
    ],
    []
  );

  return columns;
};

export default useColumns;
